import { useState } from "react";
import { Bed, ShoppingCart, Truck, FileText, ExternalLink, AlertCircle } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import PageHeader from "../components/PageHeader";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";

export default function Arredo() {
  return (
    <div className="min-h-screen bg-slate-100">
      <div className="p-4 md:p-6 lg:p-8 max-w-7xl mx-auto">
        {/* Page Header - responsive */}
        <PageHeader
          title="Arredo"
          subtitle="Arredi e ausili medicali per la tua struttura"
          icon={Bed}
          iconContainerClassName="bg-gradient-to-r from-amber-500 to-amber-600"
          iconClassName="text-white"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Coming Soon Card */}
        <Card className="max-w-2xl mx-auto">
          <CardContent className="p-8 text-center">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Bed className="w-10 h-10 text-amber-600" />
            </div>
            <Badge className="bg-amber-100 text-amber-700 mb-4">In arrivo</Badge>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">Modulo Arredo</h2>
            <p className="text-slate-600 mb-6">
              Stiamo sviluppando il modulo per la gestione degli ordini di arredi medicali. 
              Presto potrai richiedere e tracciare ordini di letti, carrozzine, ausili e 
              attrezzature per la tua struttura.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left mt-8">
              <div className="bg-slate-50 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <ShoppingCart className="w-5 h-5 text-amber-500" />
                  <span className="font-medium text-slate-700">Catalogo Prodotti</span>
                </div>
                <p className="text-sm text-slate-500">
                  Accesso al catalogo completo di arredi e ausili medicali
                </p>
              </div>
              <div className="bg-slate-50 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <Truck className="w-5 h-5 text-amber-500" />
                  <span className="font-medium text-slate-700">Tracciamento Ordini</span>
                </div>
                <p className="text-sm text-slate-500">
                  Monitora lo stato dei tuoi ordini in tempo reale
                </p>
              </div>
              <div className="bg-slate-50 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <FileText className="w-5 h-5 text-amber-500" />
                  <span className="font-medium text-slate-700">Preventivi</span>
                </div>
                <p className="text-sm text-slate-500">
                  Richiedi preventivi personalizzati per la tua struttura
                </p>
              </div>
              <div className="bg-slate-50 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <ExternalLink className="w-5 h-5 text-amber-500" />
                  <span className="font-medium text-slate-700">Integrazione Ausilium</span>
                </div>
                <p className="text-sm text-slate-500">
                  Collegamento con il portale Ausilium.it
                </p>
              </div>
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex items-start gap-3">
                <AlertCircle className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <div className="text-left">
                  <p className="font-medium text-blue-800">Nel frattempo...</p>
                  <p className="text-sm text-blue-600 mt-1 mb-3">
                    Puoi visitare direttamente il portale Ausilium.it per consultare il catalogo 
                    e effettuare ordini.
                  </p>
                  <Button 
                    variant="outline" 
                    className="border-blue-300 text-blue-700 hover:bg-blue-100"
                    onClick={() => window.open('https://www.ausilium.it', '_blank')}
                  >
                    <ExternalLink className="w-4 h-4 mr-2" />
                    Vai a Ausilium.it
                  </Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
